<template>
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" :format="dateFormat" :placeholder="datePickerPlaceholder" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    
                    <base-checkbox class="mb-3" v-model="isShowDetails">
                        Show Details
                    </base-checkbox>

                    <base-checkbox v-if="inputGroupBy == 'terminal_id'" class="mb-3" v-model="isShowSerial">
                        Show Serial Number
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="isIncludeReservation">
                        Include Reservation
                    </base-checkbox>
                    
                    <base-checkbox class="mb-3" v-model="isShowTransCount">
                        Show Transaction Count
                    </base-checkbox>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'terminal_id',
                groupOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'site_id', value: 'Site'}
                ],
                isShowDetails: false,
                isShowSerial: false,
                isIncludeReservation: false,
                isShowTransCount: false,
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                dateFormat: 'MM/DD/YYYY hh:mm A',
                datePickerPlaceholder: ['Start', 'End'],
                birSalesReports: [],
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            generateReport: async function () {
                if(this.inputGroupBy != 'terminal_id'){
                    this.isShowSerial = false;
                }

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/terminal_sales?site_id=' + this.inputSite + 
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') + 
                    '&group=' + this.inputGroupBy + '&show_details=' + this.isShowDetails + '&show_serial=' + this.isShowSerial + '&show_count=' + 
                    this.isShowTransCount + '&show_resv=' + this.isIncludeReservation, null)
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let column_count = 17
                    if(this.isShowTransCount == true){
                        column_count += 1
                    }
                    if(this.isIncludeReservation == true){
                        column_count += 3
                    }
                    
                    var doc = {}
                    if(column_count <= 19){
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2' });
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'c2' });
                    }

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    
                    var headers = []
                    
                    headers.push([]);
                    headers[0].push(
                        {content: ''},
                        {content: ''}
                    );

                    if(this.isShowTransCount == true){
                        headers[0].push({content: 'Transaction\nCount', styles: {halign: 'center'}});
                    }
                    headers[0].push(
                        {content: 'Gross\nSales', styles: {halign: 'center'}},
                        {content: 'Overall\nDiscount', styles: {halign: 'center'}}, 
                        {content: 'Total Item\nDiscount', styles: {halign: 'center'}},
                        {content: 'Rebates', styles: {halign: 'center'}},
                        {content: 'SC\nDiscount', styles: {halign: 'center'}},
                        {content: 'PWD\nDiscount', styles: {halign: 'center'}},
                        {content: 'SC\nVAT-Ex', styles: {halign: 'center'}},
                        {content: 'PWD\nVAT-Ex', styles: {halign: 'center'}},
                        {content: 'VAT\nExempt', styles: {halign: 'center'}},
                        {content: 'Zero\nRated', styles: {halign: 'center'}},
                        {content: 'Net of Discount and\nVAT-Exempt', styles: {halign: 'center'}},
                        {content: 'Returns', styles: {halign: 'center'}},
                        {content: 'Net of\nReturns', styles: {halign: 'center'}}
                    );
                    if(this.isIncludeReservation == true){
                        headers[0].push(
                            {content: 'Reservation\nCollection', styles: {halign: 'center'}},
                            {content: 'Reservation\nCancellation', styles: {halign: 'center'}},
                            {content: 'Net with\nReservation', styles: {halign: 'center'}}
                        );
                    }
                    headers[0].push({content: 'Add-On', styles: {halign: 'center'}});

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let total_trans_count = 0;
                            let total_gross_sales = 0;
                            let total_overall_discount = 0;
                            let total_item_discount = 0;
                            let total_rebates = 0;
                            let total_sc_discount = 0;
                            let total_pwd_discount = 0;
                            let total_sc_vat_exempt = 0;
                            let total_pwd_vat_exempt = 0;
                            let total_vat_exempt = 0;
                            let total_zero_rated_sales = 0;
                            let total_net_discount_vatex = 0;
                            let total_returns = 0;
                            let total_net_returns = 0;
                            let total_resv_collections = 0;
                            let total_resv_cancelations = 0;
                            let total_net_resv = 0;
                            let total_addons = 0;

                            let subtotal_trans_count = 0;
                            let subtotal_gross_sales = 0;
                            let subtotal_overall_discount = 0;
                            let subtotal_item_discount = 0;
                            let subtotal_rebates = 0;
                            let subtotal_sc_discount = 0;
                            let subtotal_pwd_discount = 0;
                            let subtotal_sc_vat_exempt = 0;
                            let subtotal_pwd_vat_exempt = 0;
                            let subtotal_vat_exempt = 0;
                            let subtotal_zero_rated_sales = 0;
                            let subtotal_net_discount_vatex = 0;
                            let subtotal_returns = 0;
                            let subtotal_net_returns = 0;
                            let subtotal_resv_collections = 0;
                            let subtotal_resv_cancelations = 0;
                            let subtotal_net_resv = 0;
                            let subtotal_addons = 0;

                            let grouper = '';

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                if(this.isShowDetails == true){
                                    if(this.inputGroupBy == 'terminal_id'){
                                        if(grouper == ''){
                                            let detail_header = ["Terminal :", reportLine.terminal_name]
                                            reportData.push(Object.assign({}, detail_header))

                                            if(this.isShowSerial == true){
                                                let detail1 = ["SN :", reportLine.serial_no]
                                                reportData.push(Object.assign({}, detail1))
                                            }
                                        } else {
                                            if(grouper != reportLine.terminal_id){
                                                let detail_header = ['Terminal :', reportLine.terminal_name];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.terminal_id
                                    }else if(this.inputGroupBy == 'user_id'){
                                        if(grouper == ''){
                                            let detail_header = ["Cashier :", reportLine.cashier_name]
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != reportLine.user_id){
                                                let detail_header = ['Cashier :', reportLine.cashier_name];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.user_id
                                    }else if(this.inputGroupBy == 'site_id'){
                                        if(grouper == ''){
                                            let detail_header = ["Site :", reportLine.site_name]
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != reportLine.user_id){
                                                let detail_header = ['Site :', reportLine.site_name];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.site_id
                                    }
                                } else {
                                    if(this.isShowSerial == true){
                                        let detail1 = ["SN :", reportLine.serial_no]
                                        reportData.push(Object.assign({}, detail1))
                                    }
                                }
                                
                                let overall_discount = Number(reportLine.total_item_discount) + Number(reportLine.rebates) + Number(reportLine.sc_discount) + Number(reportLine.pwd_discount)
                                let total_exempt = Number(reportLine.sc_vat_exempt) + Number(reportLine.pwd_vat_exempt) + Number(reportLine.vat_exempt) + Number(reportLine.zero_rated_sales)
                                let net_discount_vatex = Number(reportLine.gross_sales) - (overall_discount + total_exempt)
                                let net_returns = net_discount_vatex - Number(reportLine.returns)

                                let detail = []
                                if(this.isShowDetails == true){
                                    if(this.inputGroupBy == 'terminal_id'){
                                        detail.push('Cashier :', reportLine.cashier_name)
                                    } else if(this.inputGroupBy == 'user_id'){
                                        detail.push('Terminal :', reportLine.terminal_name)
                                    } else if(this.inputGroupBy == 'site_id'){
                                        detail.push('Terminal :', reportLine.terminal_name)
                                    }
                                } else {
                                    if(this.inputGroupBy == 'terminal_id'){
                                        detail.push('Terminal :', reportLine.terminal_name)
                                    } else if(this.inputGroupBy == 'user_id'){
                                        detail.push('Cashier :', reportLine.cashier_name)
                                    } else if(this.inputGroupBy == 'site_id'){
                                        detail.push('Site :', reportLine.site_name)
                                    }
                                }

                                if(this.isShowTransCount == true){
                                    detail.push(this.formatNumber(Number(reportLine.trans_count)));
                                }

                                detail.push(
                                    this.convertToCurrency(Number(reportLine.gross_sales)),
                                    this.convertToCurrency(overall_discount),
                                    this.convertToCurrency(Number(reportLine.total_item_discount)),
                                    this.convertToCurrency(Number(reportLine.rebates)),
                                    this.convertToCurrency(Number(reportLine.sc_discount)),
                                    this.convertToCurrency(Number(reportLine.pwd_discount)),
                                    this.convertToCurrency(Number(reportLine.sc_vat_exempt)),
                                    this.convertToCurrency(Number(reportLine.pwd_vat_exempt)),
                                    this.convertToCurrency(Number(reportLine.vat_exempt)),
                                    this.convertToCurrency(Number(reportLine.zero_rated_sales)),
                                    this.convertToCurrency(net_discount_vatex),
                                    this.convertToCurrency(Number(reportLine.returns)),
                                    this.convertToCurrency(net_returns),
                                );

                                if(this.isIncludeReservation == true){
                                    var net_resv = Number(net_returns) + Number(reportLine.resv_collections) - Number(reportLine.resv_cancellations)

                                    detail.push(
                                        this.convertToCurrency(Number(reportLine.resv_collections)),
                                        this.convertToCurrency(Number(reportLine.resv_cancellations)),
                                        this.convertToCurrency(net_resv)
                                    );
                                }

                                detail.push(this.convertToCurrency(Number(reportLine.addons)));
                                reportData.push(Object.assign({}, detail))

                                if(this.isShowTransCount == true){
                                    total_trans_count += Number(reportLine.trans_count);
                                }
                                total_gross_sales += Number(reportLine.gross_sales);
                                total_overall_discount += overall_discount;
                                total_item_discount += Number(reportLine.total_item_discount);
                                total_rebates += Number(reportLine.rebates);
                                total_sc_discount += Number(reportLine.sc_discount);
                                total_pwd_discount += Number(reportLine.pwd_discount);
                                total_sc_vat_exempt += Number(reportLine.sc_vat_exempt);
                                total_pwd_vat_exempt += Number(reportLine.pwd_vat_exempt);
                                total_vat_exempt += Number(reportLine.vat_exempt);
                                total_zero_rated_sales += Number(reportLine.zero_rated_sales);
                                total_net_discount_vatex += net_discount_vatex;
                                total_returns += Number(reportLine.returns);
                                total_net_returns += net_returns;
                                total_addons += Number(reportLine.addons);
                                if(this.isIncludeReservation == true){
                                    total_resv_collections += Number(reportLine.resv_collections);
                                    total_resv_cancelations += Number(reportLine.resv_cancellations);
                                    total_net_resv += net_resv;
                                }

                                if(this.isShowTransCount == true){
                                    subtotal_trans_count += Number(reportLine.trans_count);
                                }
                                subtotal_gross_sales += Number(reportLine.gross_sales);
                                subtotal_overall_discount += overall_discount;
                                subtotal_item_discount += Number(reportLine.total_item_discount);
                                subtotal_rebates += Number(reportLine.rebates);
                                subtotal_sc_discount += Number(reportLine.sc_discount);
                                subtotal_pwd_discount += Number(reportLine.pwd_discount);
                                subtotal_sc_vat_exempt += Number(reportLine.sc_vat_exempt);
                                subtotal_pwd_vat_exempt += Number(reportLine.pwd_vat_exempt);
                                subtotal_vat_exempt += Number(reportLine.vat_exempt);
                                subtotal_zero_rated_sales += Number(reportLine.zero_rated_sales);
                                subtotal_net_discount_vatex += net_discount_vatex;
                                subtotal_returns += Number(reportLine.returns);
                                subtotal_net_returns += net_returns;
                                subtotal_addons += Number(reportLine.addons);
                                if(this.isIncludeReservation == true){
                                    subtotal_resv_collections += Number(reportLine.resv_collections);
                                    subtotal_resv_cancelations += Number(reportLine.resv_cancellations);
                                    subtotal_net_resv += net_resv;
                                }

                                if(i == this.birSalesReports.length-1){
                                    if(this.isShowDetails == true){
                                        let total = [];

                                        total.push("", "Total :");
                                        if(this.isShowTransCount == true){
                                            total.push(this.formatNumber(total_trans_count));
                                        }
                                        total.push(
                                            this.convertToCurrency(total_gross_sales),
                                            this.convertToCurrency(total_overall_discount),
                                            this.convertToCurrency(total_item_discount),
                                            this.convertToCurrency(total_rebates),
                                            this.convertToCurrency(total_sc_discount),
                                            this.convertToCurrency(total_pwd_discount),
                                            this.convertToCurrency(total_sc_vat_exempt),
                                            this.convertToCurrency(total_pwd_vat_exempt),
                                            this.convertToCurrency(total_vat_exempt),
                                            this.convertToCurrency(total_zero_rated_sales),
                                            this.convertToCurrency(total_net_discount_vatex),
                                            this.convertToCurrency(total_returns),
                                            this.convertToCurrency(total_net_returns)
                                        );
                                        if(this.isIncludeReservation == true){
                                            total.push(
                                                this.convertToCurrency(total_resv_collections),
                                                this.convertToCurrency(total_resv_cancelations),
                                                this.convertToCurrency(total_net_resv)
                                            );
                                        }

                                        total.push(this.convertToCurrency(total_addons));
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total));    
                                    }
                                    
                                    let subtotal = [];

                                    if(this.inputGroupBy == 'site_id'){
                                        subtotal.push("", "Grand Total :");
                                    } else {
                                        subtotal.push("", "Site Total :");
                                    }
                                    
                                    if(this.isShowTransCount == true){
                                        subtotal.push(this.formatNumber(subtotal_trans_count));
                                    }
                                    subtotal.push(
                                        this.convertToCurrency(subtotal_gross_sales),
                                        this.convertToCurrency(subtotal_overall_discount),
                                        this.convertToCurrency(subtotal_item_discount),
                                        this.convertToCurrency(subtotal_rebates),
                                        this.convertToCurrency(subtotal_sc_discount),
                                        this.convertToCurrency(subtotal_pwd_discount),
                                        this.convertToCurrency(subtotal_sc_vat_exempt),
                                        this.convertToCurrency(subtotal_pwd_vat_exempt),
                                        this.convertToCurrency(subtotal_vat_exempt),
                                        this.convertToCurrency(subtotal_zero_rated_sales),
                                        this.convertToCurrency(subtotal_net_discount_vatex),
                                        this.convertToCurrency(subtotal_returns),
                                        this.convertToCurrency(subtotal_net_returns)
                                    );
                                    if(this.isIncludeReservation == true){
                                        subtotal.push(
                                            this.convertToCurrency(subtotal_resv_collections),
                                            this.convertToCurrency(subtotal_resv_cancelations),
                                            this.convertToCurrency(subtotal_net_resv)
                                        );
                                    }

                                    subtotal.push(this.convertToCurrency(subtotal_addons));
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, subtotal));
                                } else {
                                    if(this.isShowDetails == true){
                                        let current_grouper = ""
                                        let next_grouper = ""

                                        if(this.inputGroupBy == 'terminal_id'){
                                            current_grouper = reportLine.terminal_id
                                            next_grouper = this.birSalesReports[i+1].terminal_id
                                        } else if(this.inputGroupBy == 'user_id'){
                                            current_grouper = reportLine.user_id
                                            next_grouper = this.birSalesReports[i+1].user_id
                                        } else if(this.inputGroupBy == 'site_id'){
                                            current_grouper = reportLine.user_id
                                            next_grouper = this.birSalesReports[i+1].site_id
                                        }

                                        if(current_grouper != next_grouper){
                                            let total = [];

                                            total.push("", "Total :");
                                            if(this.isShowTransCount == true){
                                                total.push(this.formatNumber(total_trans_count));
                                            }
                                            total.push(
                                                this.convertToCurrency(total_gross_sales),
                                                this.convertToCurrency(total_overall_discount),
                                                this.convertToCurrency(total_item_discount),
                                                this.convertToCurrency(total_rebates),
                                                this.convertToCurrency(total_sc_discount),
                                                this.convertToCurrency(total_pwd_discount),
                                                this.convertToCurrency(total_sc_vat_exempt),
                                                this.convertToCurrency(total_pwd_vat_exempt),
                                                this.convertToCurrency(total_vat_exempt),
                                                this.convertToCurrency(total_zero_rated_sales),
                                                this.convertToCurrency(total_net_discount_vatex),
                                                this.convertToCurrency(total_returns),
                                                this.convertToCurrency(total_net_returns)
                                            );
                                            if(this.isIncludeReservation == true){
                                                total.push(
                                                    this.convertToCurrency(total_resv_collections),
                                                    this.convertToCurrency(total_resv_cancelations),
                                                    this.convertToCurrency(total_net_resv)
                                                );
                                            }

                                            total.push(this.convertToCurrency(total_addons));
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, total));

                                            total_trans_count = 0;
                                            total_gross_sales = 0;
                                            total_overall_discount = 0;
                                            total_item_discount = 0;
                                            total_rebates = 0;
                                            total_sc_discount = 0;
                                            total_pwd_discount = 0;
                                            total_sc_vat_exempt = 0;
                                            total_pwd_vat_exempt = 0;
                                            total_vat_exempt = 0;
                                            total_zero_rated_sales = 0;
                                            total_net_discount_vatex = 0;
                                            total_returns = 0;
                                            total_net_returns = 0;
                                            total_resv_collections = 0;
                                            total_resv_cancelations = 0;
                                            total_net_resv = 0;
                                            total_addons = 0;
                                        }
                                    }
                                }
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let grouper_name = ""
                        if(this.inputGroupBy == 'terminal_id'){
                            grouper_name = " by Terminal"
                        } else if (this.inputGroupBy == "user_id"){
                            grouper_name = " by Cashier"
                        } else if (this.inputGroupBy == "site_id"){
                            grouper_name = " by Site"
                        }

                        let design_x = 580
                        let design_y = 400
                        if(column_count > 19){
                            design_x = 630
                            design_y = 445
                        }

                        doc.text(15,20,"Terminal Sales Report" + grouper_name)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if (this.inputGroupBy != 'site_id'){
                            doc.text(design_x,20,siteSpecific[x].report_details[0].site_name, "right")
                        }
                        doc.text(15,25,"For Period of " + this.inputDate[0].format('MMMM DD, YYYY h:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY h:mm A'))

                        var colStyle = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 30, halign: 'left'}
                        }
                        let colIndex = 1

                        //trans count
                        if(this.isShowTransCount == true){
                            Object.assign(colStyle, {
                                [colIndex + 1]: {cellWidth: 30}
                            })
                            colIndex += 1
                        }
                        
                        Object.assign(colStyle, {
                            [colIndex + 1]: {cellWidth: 30},
                            [colIndex + 2]: {cellWidth: 30},
                            [colIndex + 3]: {cellWidth: 30},
                            [colIndex + 4]: {cellWidth: 30},
                            [colIndex + 5]: {cellWidth: 30},
                            [colIndex + 6]: {cellWidth: 30},
                            [colIndex + 7]: {cellWidth: 30},
                            [colIndex + 8]: {cellWidth: 30},
                            [colIndex + 9]: {cellWidth: 30},
                            [colIndex + 10]: {cellWidth: 30},
                            [colIndex + 11]: {cellWidth: 40},
                            [colIndex + 12]: {cellWidth: 30},
                            [colIndex + 13]: {cellWidth: 30}
                        })
                        colIndex += 13

                        //reservation
                        if(this.isIncludeReservation == true){
                            Object.assign(colStyle, {
                                [colIndex + 1]: {cellWidth: 30},
                                [colIndex + 2]: {cellWidth: 30},
                                [colIndex + 3]: {cellWidth: 30}
                            })
                            colIndex += 3
                        }

                        //addons
                        Object.assign(colStyle, {
                            [colIndex + 1]: {cellWidth: 30}
                        })
                        colIndex += 1

                        doc.autoTable(
                            {
                                startY: 30,
                                head: headers, 
                                body: reportData, 
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 9,
                                    halign: 'right'
                                },
                                columnStyles: colStyle, 
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[1] == 'Total :' || data.row.raw[1] == 'Site Total :' || data.row.raw[1] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            }
                        );
                        
                        doc.text(15,design_y,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(design_x,design_y,"Terminal Sales Report" + grouper_name, "right")

                        doc.text(15,design_y+5,"Print Date: " + moment().format(this.dateFormat))
                        doc.text(design_x,design_y+5,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                    }

                    //doc.save(`Terminal_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
            }
        }
    };
</script>

<style></style>